// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f2e21aa8","239":"c26aafbc","455":"f1356e91"}[chunkId] + ".chunk.js";
};